import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const cat = categoryMap[article.category];

  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden aspect-video">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 高清无码视频编码技术`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-2.5 py-1 rounded-full text-xs bg-primary-500 text-background-50 whitespace-nowrap">
              {cat?.name || article.category}
            </span>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${article.slug}`}>
          <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3 flex-wrap">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
          </div>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
      </div>
    </article>
  );
}